





























































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Search from "@/components/Search.vue";

@Component({
  components: {
    Search,
  },
})
export default class DefaultVue extends Vue {
  private tags = [
    { tag: "Equity" },
    { tag: "Fixed Income" },
    { tag: "FX" },
    { tag: "Commodity" },
    { tag: "Classic" },
  ];
  private collections = [
    { tag: "Shelf" },
    { tag: "Special Collection" },
    { tag: "Weekly Reading" },
    { tag: "ATW" },
    { tag: "Internal,Primer", name: "In-House Primers" },
    { tag: "Primer", name: "Primers" },
    { tag: "BDO" },
    { tag: "Bank Credit Analyst" },
    { tag: "GIS" },
    { tag: "IRSW", name: "Rates Strategy" },
    { tag: "FOMC,Transcript", name: "FOMC Transcript" },
    { tag: "devoe", name: "DeVoe" },
  ];
  private searchKey = "";
  private searchMode = false;

  public load() {
    const queryQuery = this.$route.query;

    if (queryQuery.tags != null) {
      this.searchMode = true;
    }

    this.searchKey =
      (queryQuery.query as string) +
      (queryQuery.tags as string) +
      String(this.searchMode);
  }

  @Watch("$route.query.tags")
  public reloadForTags(value: any, oldValue: any) {
    this.load();
  }

  @Watch("$route.query.query")
  public reloadForQuery(value: any, oldValue: any) {
    this.load();
  }

  private mounted() {
    this.load();
  }

  private goToTag(tag: string) {
    this.$router.push("/search?query=tag:" + tag);
  }
}
